import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TankTypeSelectComponent
} from '@shared/component/form-controls/select/tank-type-select/tank-type-select.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorModule } from '@shared/component';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TourAnchorMatMenuDirective, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';
import { PipeModule } from '@shared/pipe/pipe.module';

@NgModule({
  declarations: [TankTypeSelectComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    FormsModule,
    ValidationErrorModule,
    MatRadioModule,
    PipeModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TourAnchorMatMenuDirective,
    TourStepTemplateComponent,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    TankTypeSelectComponent
  ]
})
export class TankTypeSelectModule { }
